import { useQuery } from "@tanstack/react-query";

import QueryKey from "@app/constants/QueryKeys.ts";
import { UserStatusFilter } from "@app/models/User.ts";
import { useUserService } from "@app/services/api/useUserService.ts";

export const useUsers = (
  page: number,
  size: number,
  query: string | undefined,
  departmentIds: string[] | undefined,
  status: UserStatusFilter,
) => {
  const { fetchUsersWithPage } = useUserService();

  const { data, error, isLoading } = useQuery({
    queryKey: [
      QueryKey.USERS,
      page,
      size,
      query ?? undefined,
      departmentIds ?? undefined,
      status,
    ],
    queryFn: () => fetchUsersWithPage(page, size, query, departmentIds, status),
  });

  return {
    users: data,
    error,
    isLoading,
  };
};
